import { months } from 'moment';

const getDefaultState = () => {
  return {
    limits: {
      deposit: {
        week: { actuelValue: null, futureValue: null, message: null },
      },
      time: {
        day: { actuelValue: null, futureValue: null, message: null },
        week: { actuelValue: null, futureValue: null, message: null },
        month: { actuelValue: null, futureValue: null, message: null },
      },
      loss: {
        day: { actuelValue: null, futureValue: null, message: null },
        week: { actuelValue: null, futureValue: null, message: null },
        month: { actuelValue: null, futureValue: null, message: null },
      },
    },
  };
};

const state = getDefaultState();

const getters = {
  getLimitValue: (state) => (category, period) => {
    return state.limits[category][period];
  },

  getLimits: (state) => {
    return state.limits;
  },
};

const actions = {
  reset({ commit }) {
    commit('RESET');
  },
};

const mutations = {
  RESET(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },
  RESET_CATEGORY(state, category) {
    // on reset les valeurs de la categorie
    Object.keys(state.limits[category]).forEach((period) => {
      state.limits[category][period].actuelValue = null;
      state.limits[category][period].futureValue = null;
      state.limits[category][period].message = null;
    });
  },
  SET_GLOBAL_LIMITS(state, limits) {
    state.limits = limits;
  },
  // Mise a jour des limit de categorie
  SET_LIMITS(state, payload) {
    // Parcours fonctionnel des catégories sans for...of
    Object.entries(payload).forEach(([category, periods]) => {
      if (!state.limits[category]) return;

      const updated = Object.entries(periods).reduce(
        (acc, [period, { actuelLimit, futureLimit, applicableDate }]) => {
          acc[period] = {
            actuelValue: actuelLimit ?? null,
            futureValue: futureLimit ?? null,
            message: applicableDate ?? null,
          };
          return acc;
        },
        {}
      );

      // state.limits[category] = updated;
      Object.keys(updated).forEach((period) => {
        if (state.limits[category][period]) {
          state.limits[category][period] = { ...updated[period] };
        }
      });
    });
  },
  // Mise a jour et suppression d'une limite
  SET_CATEGORY_LIMIT(state, payload) {
    const [[category, periods]] = Object.entries(payload);
    const [[period, data]] = Object.entries(periods);

    if (!state.limits[category] || !state.limits[category][period]) return;

    state.limits[category][period] = {
      ...state.limits[category][period],
      actuelValue: data.actuelLimit ?? null,
      futureValue: data.futureLimit ?? null,
      message: data.applicableDate ?? null,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
